import React from 'react';
import { Observer } from 'mobx-react-lite';
import { Field, Form, ErrorMessage } from 'formik';
import ParadigmInput from '../../../../material/input';
import ParadigmButton from '../../../../material/button';
import { ModalActionsWrapper } from '../../../../material/modal';
import { useEntities } from '../../account/components/add-keys/use-entities';
import ErrorMessageRender from '#/components/ErrorMessage';

const AddKeyForm = ({ isSubmitting, onClose, source, errors }) => {
  const { entityOptions } = useEntities(source);
  const hasErrors = Object.keys(errors).length > 0;

  return (
    <Observer>
      {() => (
        <Form noValidate>
          <Field
            name="name"
            label="Name"
            component={ParadigmInput}
            placeholder="Name"
            required
            autoFocus
          />
          <ErrorMessage
            name="name"
            render={(message) => <ErrorMessageRender message={message} />}
          />

          <Field
            name="entity"
            label="Entity"
            placeholder="Entity"
            component={ParadigmInput}
            select
            required
          >
            {entityOptions}
          </Field>
          <ErrorMessage
            name="entity"
            render={(message) => <ErrorMessageRender message={message} />}
          />

          <Field
            name="account_address"
            label="Account Address"
            component={ParadigmInput}
            required
            placeholder="0x..."
          />
          <ErrorMessage
            name="account_address"
            render={(message) => <ErrorMessageRender message={message} />}
          />

          <Field
            name="subkey"
            label="Trading Key (private)"
            component={ParadigmInput}
            required
            placeholder="0x..."
          />
          <ErrorMessage
            name="subkey"
            render={(message) => <ErrorMessageRender message={message} />}
          />
          <div
            style={{
              fontSize: '0.75rem',
              color: '#aaa',
              marginTop: '-8px',
              marginBottom: '8px',
            }}
          >
            Must be a trading key private key, not your account key.{' '}
            <a
              href="https://docs.paradex.trade/api/general-information/api-authentication#subkeys"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#f5c542' }}
            >
              How to generate a trading key ↗
            </a>
          </div>

          <ModalActionsWrapper>
            <ParadigmButton secondary text="Cancel" onClick={onClose} />
            <ParadigmButton
              disabled={hasErrors}
              type="submit"
              busy={isSubmitting}
              text="Add"
            />
          </ModalActionsWrapper>
        </Form>
      )}
    </Observer>
  );
};

export default AddKeyForm;
